const HEADER_HEIGHT = '40px'
const FOOTER_HEIGHT = '56px'
const CONTAINER_MARGIN = '8px'

export const styles = {
  form: {
    overflowY: 'auto',
    margin: CONTAINER_MARGIN,
    paddingTop: CONTAINER_MARGIN,

    minHeight: `calc(100vh - ${FOOTER_HEIGHT} - ${HEADER_HEIGHT} - (${CONTAINER_MARGIN} * 2))`,
    height: '100%',
  },
}
